// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"SellerProfile_mainContent__1o3mP","sellerContent":"SellerProfile_sellerContent__3SjDD"};